import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadWayBillByIdFailed, loadWayBillByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* loadWayBillById(action) {
  try {
    const url = `${BACKEND_URL_V2}/dict/waybills/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadWayBillByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadWayBillByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadWayBillByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
